import { FundDocument } from '../types';
import { useFileUploadMutation } from 'src/data-capture/hooks/useFileUploadMutation';
import { useCreate } from '@refinedev/core';
import { useState } from 'react';
import { Logger } from 'src/utils/Logger';

export const useCreateFundDocument = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { uploadToFileStorage } = useFileUploadMutation();
  const { mutateAsync } = useCreate<FundDocument>();

  const createFundDocument = async (
    fundId: string,
    file: File,
    document: Omit<FundDocument, 'id'>,
  ) => {
    try {
      setIsLoading(true);
      await uploadToFileStorage({ file });
      await mutateAsync({
        resource: `funds/${fundId}/files`,
        values: document,
      });
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      Logger.error('Failed to upload fund file', e);
      throw e;
    }
  };

  return {
    createFundDocument,
    isLoading,
  };
};
